import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Home from '../home/Home';
import Login from '../login/Login';
import Profile from '../profile/Profile';
import Register from '../register/Register';
import Layout from '../../components/Layout/Layout';
import PrivateRoute from '../../components/PrivateRoute/PrivateRoute';
import Page404 from '../Page404/Page404';

const MainPage = () => {

    return (
        <div>

            <Router>
                <Routes>
                    {/* =========  RESTRICTED ROUTE  =========== */}
                        <Route path='/' element={<Layout />}>
                            <Route path='/' element={<Home />}></Route>
                            <Route path="/profile/:id" element={<Profile />}></Route>
                        </Route>
                    <Route element={<PrivateRoute />}>
                    </Route>
                    {/* =========  RESTRICTED ROUTE  =========== */}

                    <Route path='/login' element={<Login />}></Route>
                    <Route path='/register' element={<Register />}></Route>
                    <Route path='*' element={<Page404 />}></Route>
                </Routes>
            </Router>

        </div>
    );
}

export default MainPage;